// extracted by mini-css-extract-plugin
module.exports = {"container":"e_eB","question":"e_fB","button":"e_gB","buttonNegative":"e_hB","buttonPositive":"e_iB","icon":"e_jB","iconNegative":"e_kB","iconPositive":"e_lB"};